<div class="-docpage-skeleton">
  <div class="-docpage-content">
    <div class="-left-pane">
      <div class="-secondary-masthead-skeleton">
        <wp-skeleton height="36px" [width]="'100%'" [loading]="true"></wp-skeleton>
        <wp-skeleton height="16px" [width]="'62%'" [loading]="true"></wp-skeleton>
        <wp-skeleton height="14px" [width]="'100%'" [loading]="true"></wp-skeleton>
        <wp-skeleton height="14px" [width]="'96%'" [loading]="true"></wp-skeleton>
        <wp-skeleton height="14px" [width]="'88%'" [loading]="true"></wp-skeleton>

        <div class="-secondary-masthead-bottom-row">
          <wp-skeleton height="34px" [width]="'220px'" [loading]="true"></wp-skeleton>
          <wp-skeleton height="34px" [width]="'190px'" [loading]="true"></wp-skeleton>
        </div>
      </div>

      <div class="-small-card-row-skeleton row">
        @for (card of [1,2,3]; track card) {
        <div class="col-sm-4">
          <div class="-small-card-skeleton">
            <wp-skeleton height="200px" [width]="'100%'" [loading]="true"></wp-skeleton>
            <wp-skeleton height="24px" [width]="'78%'" [loading]="true"></wp-skeleton>
            <wp-skeleton height="14px" [width]="'100%'" [loading]="true"></wp-skeleton>
            <wp-skeleton height="14px" [width]="'92%'" [loading]="true"></wp-skeleton>
          </div>
        </div>
        }
      </div>

      @for (section of [1,2]; track section) {
      <div class="-content-section-skeleton">
        <wp-skeleton height="30px" [width]="'36%'" [loading]="true"></wp-skeleton>
        <wp-skeleton height="14px" [width]="'100%'" [loading]="true"></wp-skeleton>
        <wp-skeleton height="14px" [width]="'96%'" [loading]="true"></wp-skeleton>
        <wp-skeleton height="14px" [width]="'92%'" [loading]="true"></wp-skeleton>
        <wp-skeleton height="14px" [width]="'78%'" [loading]="true"></wp-skeleton>
      </div>
      }
    </div>
  </div>
</div>
